import * as authentication from "../../common/actions/authentication";
import * as customerSubscriptions from "../actions/customerSubscriptions.js";

import Immutable from "seamless-immutable";

const defaultState = () => {
    return Immutable({
        subscriptions: [
            // {
            //     "subscriptionType": 0,
            //     "web": true,
            //     "email": true,
            //     "sms": true
            // }
        ],
        mailAddressInvoice: "",
        mailAddressMonthReport: "",
        mailAddressDeliveryNote: "",
        loading: false,
        saving: false
    });
};

/**
 * Customer subscriptions reducer
 * @param {Object} state
 * @param {{type: string}} action
 * @return {*}
 */
export default function(state = defaultState(), action) {
    switch(action.type) {
    case customerSubscriptions.CUSTOMER_SUBSCRIPTIONS_LOADING:
        return state.merge({
            loading: true
        });
    case customerSubscriptions.CUSTOMER_SUBSCRIPTIONS_LOADED:
        return state.merge({
            ...action.subscriptions,
            loading: false
        });
    case customerSubscriptions.CUSTOMER_SUBSCRIPTIONS_FAILED:
        return state.merge({
            loading: false
        });
    case customerSubscriptions.CUSTOMER_SUBSCRIPTIONS_SAVING:
        return state.merge({
            saving: true
        });
    case customerSubscriptions.CUSTOMER_SUBSCRIPTIONS_SAVED:
        return state.merge({
            ...action.customerSubscriptions,
            saving: false
        });
    case customerSubscriptions.CUSTOMER_SUBSCRIPTIONS_FAILED_SAVE:
        return state.merge({
            saving: false
        });
    case authentication.LOGGED_OUT:
        return defaultState();
    default:
        return state;
    }
}